import React, { useEffect } from 'react';
import { CheckCircle2, X } from 'lucide-react';

export interface ToastPayload {
  message: string;
  type?: 'success' | 'info' | 'error';
}

/** Inline toast in pagina (naast globale wt:toast). */
const RecruiterHeadsUpToast: React.FC<{
  payload: ToastPayload | null;
  onDismiss: () => void;
}> = ({ payload, onDismiss }) => {
  useEffect(() => {
    if (!payload) return;
    const t = setTimeout(onDismiss, 4200);
    return () => clearTimeout(t);
  }, [payload, onDismiss]);

  if (!payload) return null;
  const isError = payload.type === 'error';
  const isInfo = payload.type === 'info';
  return (
    <div
      role="status"
      className={`pointer-events-auto flex max-w-md items-start gap-3 rounded-2xl border px-4 py-3 shadow-lg backdrop-blur-sm ${
        isError
          ? 'border-red-200 bg-red-50 text-red-900'
          : isInfo
            ? 'border-slate-200 bg-white text-slate-800'
            : 'border-emerald-200 bg-emerald-50 text-emerald-900'
      }`}
    >
      <CheckCircle2 className={`mt-0.5 h-5 w-5 shrink-0 ${isError ? 'text-red-500' : 'text-emerald-600'}`} aria-hidden />
      <p className="flex-1 text-sm font-semibold leading-snug">{payload.message}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="rounded-lg p-1 text-slate-500 hover:bg-black/5"
        aria-label="Sluiten"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

/** TODO: Supabase — persist `RecruiterNotification` en push/e-mail naar recruiter. */
export function dispatchGlobalToast(message: string, type: ToastPayload['type'] = 'success') {
  window.dispatchEvent(new CustomEvent('wt:toast', { detail: { message, type } }));
}

export default RecruiterHeadsUpToast;
